import { SET_DOWNLOAD_IN_PROGRESS } from '../actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const setDownloadInProgress = (downloadTypeId, id, value) => ({
  type: SET_DOWNLOAD_IN_PROGRESS,
  downloadTypeId,
  id,
  value,
});
